<template>
    <v-navigation-drawer
      v-model="show"
      absolute
      temporary
      height="100%"
      color="primary"
      width=""
    >
        <v-row
            align="center"
            justify="center"
            class="job-links pa-0"
        >
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                v-for="(module, index) in modules"
                :key="`mod-${index}`"
                class="pa-0"
            >
                <v-card
                    class="single-module d-flex flex-wrap justify-center align-content-center"
                    light
                    outlined
                    color="#1565c0"
                    tile
                    :to="module.link + cid"
                    v-if="module.title == 'Customer'"
                >
                    <v-card-title class="pt-4 pb-0 justify-center">    
                        <v-icon
                            large
                            color="secondary"
                        >
                            {{ module.icon }}
                        </v-icon>                         
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="subtitle-1 font-weight-bold white--text text-uppercase">{{ module.title }}</span>
                    </v-card-text>
                </v-card>
                <v-card
                    class="single-module d-flex flex-wrap justify-center align-content-center"
                    light
                    outlined
                    color="#1565c0"
                    tile
                    :to="module.link + id"
                    v-else
                >
                    <v-card-title class="pt-4 pb-0 justify-center">    
                        <v-icon
                            large
                            color="secondary"
                        >
                            {{ module.icon }}
                        </v-icon>                         
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="subtitle-1 font-weight-bold white--text text-uppercase">{{ module.title }}</span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-navigation-drawer>
</template>

<script>
  export default {
    props: ['show', 'id', 'cid'],
    data: () => ({
        group: null,
        modules: [
            {
                title: 'Dashboard',
                icon: 'mdi-view-dashboard',
                link: '/job/main/'                  
            },
            {
                title: 'Edit Job Details',
                icon: 'mdi-check-all',
                link: '/job/details/'                     
            },
            {
                title: 'Customer',
                icon: 'mdi-account',
                link: '/customer/'                      
            },
            {
                title: 'Assigness',
                icon: 'mdi-account-switch',
                link: '/job/assignees/'                      
            },
            {
                title: 'Punchlist',
                icon: 'mdi-checkbox-marked-outline',
                link: '/job/punch_list/'                    
            },
            {
                title: 'Custom Punchlist',
                icon: 'mdi-checkbox-marked-outline',
                link: '/job/custom_punch_list/'                    
            },
            {
                title: 'Phases',
                icon: 'mdi-clipboard-list',
                link: '/job/phase_list/'  
            },
            {
                title: 'Media',
                icon: 'mdi-file-image',
                link: '/job/media/'
            },
            {
                title: 'Chat',
                icon: 'mdi-message',
                link: '/job/chat/' 
            },
            {
                title: 'Equipment',
                icon: 'mdi-cube',
                link: '/job/equipment/' 
            },   
            {
                title: 'Warranty',
                icon: 'mdi-marker-check',
                link: '/job/warranty/'  
            },
            {
                title: 'Activity Log',
                icon: 'mdi-swap-horizontal',
                link: '/job/activities/'
            },                  
        ]
    }),
    created() {

    },
    watch: {
        group(newVal) {
            this.$emit('update-drawer', newVal)
        },
        show(newVal) { // watch it
            this.$emit('update-drawer', newVal)
        },
    },
    methods: {

    }
  }
</script>

<style lang="sass">
.v-navigation-drawer--bottom
    &.v-navigation-drawer--is-mobile 
        max-height: 100%!important

.v-navigation-drawer
    .single-module  
        min-height: calc((100vh - 112px) / 6)
</style>